module.exports = __webpack_public_path__ + "img/diagram-triangle.1fe90b7d.svg";